import { createSlice } from '@reduxjs/toolkit'

export const selectedStepSlicer = createSlice({
  name: 'selectedStep',
  initialState: {
    value: 0
  },
  reducers: {

    change: (state, action) => {
      console.log(state.value)
      switch  (action.payload) {
        case 0:
          state.value = action.payload;
          break;
        case 1:
          state.value = action.payload;
          break;
        case 2:
          state.value = action.payload;
          break;
        case 3:
          state.value = action.payload;
          break;
        case 4:
          state.value = action.payload;
          break;
        case 5:
          state.value = action.payload;
          break;
        // ... more cases
        default:
          break;
      }
     
    },
  },
})

// Action creators are generated for each case reducer function
export const { change } = selectedStepSlicer.actions

export default selectedStepSlicer.reducer